import type React from 'react';

import {
	EditSquareFilledIcon,
	EditSquareIcon,
	GovBuildingFilledIcon,
	GovBuildingIcon,
	HomeFilledIcon,
	HomeIcon,
	SpeakerFilledIcon,
	SpeakerIcon,
} from '@change/ds-icons';

import type { I18n } from '@change-corgi/core/i18n';

import { NavBadge } from './components/NavBadge';

export type NavigationSection = 'home' | 'share' | 'decision-maker' | 'updates';

export type NavigationItem = {
	selectedIcon: React.ReactNode;
	icon: React.ReactNode;
	id: NavigationSection;
	desktopLabel: string;
	mobileLabel: string;
	ariaLabel: string;
	section: NavigationSection;
	badge?: React.ReactNode;
	dataQa: string;
};

export const getNavigationItems = (translate: I18n['translate']): Record<NavigationSection, NavigationItem> => ({
	home: {
		selectedIcon: <HomeFilledIcon size="small" />,
		icon: <HomeIcon size="small" />,
		id: 'home',
		desktopLabel: translate('corgi.petition.starter_dashboard_v2.navigation.home.desktop_label'),
		mobileLabel: translate('corgi.petition.starter_dashboard_v2.navigation.home.mobile_label'),
		ariaLabel: translate('corgi.petition.starter_dashboard_v2.navigation.home.aria_label'),
		section: 'home',
		dataQa: 'home-tab',
	},
	share: {
		selectedIcon: <SpeakerFilledIcon size="small" />,
		icon: <SpeakerIcon size="small" />,
		id: 'share',
		desktopLabel: translate('corgi.petition.starter_dashboard_v2.navigation.share.desktop_label'),
		mobileLabel: translate('corgi.petition.starter_dashboard_v2.navigation.share.mobile_label'),
		ariaLabel: translate('corgi.petition.starter_dashboard_v2.navigation.share.aria_label'),
		section: 'share',
		badge: <NavBadge label={translate('corgi.petition.starter_dashboard_v2.navigation.share.badge_label')} />,
		dataQa: 'share-tab',
	},
	'decision-maker': {
		selectedIcon: <GovBuildingFilledIcon size="small" />,
		icon: <GovBuildingIcon size="small" />,
		id: 'decision-maker',
		desktopLabel: translate('corgi.petition.starter_dashboard_v2.navigation.decision_maker.desktop_label'),
		mobileLabel: translate('corgi.petition.starter_dashboard_v2.navigation.decision_maker.mobile_label'),
		ariaLabel: translate('corgi.petition.starter_dashboard_v2.navigation.decision_maker.aria_label'),
		section: 'decision-maker',
		dataQa: 'dm-tab',
	},
	updates: {
		selectedIcon: <EditSquareFilledIcon size="small" />,
		icon: <EditSquareIcon size="small" />,
		id: 'updates',
		desktopLabel: translate('corgi.petition.starter_dashboard_v2.navigation.updates.desktop_label'),
		mobileLabel: translate('corgi.petition.starter_dashboard_v2.navigation.updates.mobile_label'),
		ariaLabel: translate('corgi.petition.starter_dashboard_v2.navigation.updates.aria_label'),
		section: 'updates',
		dataQa: 'update-tab',
	},
});
